import { useState } from 'react';

interface Props {
  /** Short plain-English explanation. Keep to one sentence ideally. */
  children: React.ReactNode;
  /** Aria label for the trigger. Defaults to "Help". */
  label?: string;
}

/**
 * Inline ? help marker. Tap to toggle a one-line explanation below the field.
 * Place inside a <label> next to the field name, e.g.
 *   <label>LOLER cert <Help>Lifting kit cert — telehandlers, slings, hoists.</Help></label>
 */
export function Help({ children, label = 'Help' }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <span className="help-wrap">
      <button
        type="button"
        className={`help-trigger ${open ? 'open' : ''}`}
        aria-expanded={open}
        aria-label={label}
        onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}
      >
        ?
      </button>
      {open && <span className="help-popover">{children}</span>}
    </span>
  );
}
